export default "__VITE_ASSET__CpNR$q5t__"